import { AgGridModule } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { ToastrModule } from 'ngx-toastr';
import { AchMaxTransferAmountComponent } from '../create-request/components/ach-max-transfer-amount/ach-max-transfer-amount.component';
import { ViewMoveMoneyPageComponent } from '../preview/components/view-move-money-page/view-move-money-page.component';
import { ActionsLinkComponent } from './actions-link/actions-link.component';
import { AccountDetailsSectionComponent } from './components/account-details-section/account-details-section.component';
import { AchConfirmMessageComponent } from './components/ach-confirm-message/ach-confirm-message.component';
import { AmountFieldComponent } from './components/amount-field/amount-field.component';
import { AmountTypeSelectorComponent } from './components/amount-type-selector/amount-type-selector.component';
import { BannersComponent } from './components/banners/banners.component';
import { CancelLinkModalComponent } from './components/cancel-link-modal/cancel-link-modal.component';
import { CancelModalV2Component } from './components/cancel-modal-v2/cancel-modal-v2.component';
import { CardComponent } from './components/card/card.component';
import { CashieringIraAgreementModalComponent } from './components/cashiering-ira-agreement-modal/cashiering-ira-agreement-modal.component';
import { ClientAuthDetailsSectionComponent } from './components/client-auth-details-section/client-auth-details-section.component';
import { ClientAuthorizationComponent } from './components/client-authorization/client-authorization.component';
import { ConfirmPendReasonComponent } from './components/confirm-pend-reason/confirm-pend-reason.component';
import { ConfirmationDetailsSectionComponent } from './components/confirmation-details-section/confirmation-details-section.component';
import { ConfirmationPopupComponent } from './components/confirmation-popup/confirmation-popup.component';
import { ControlLabelComponent } from './components/controls/control-label/control-label.component';
import { DatePickerControlComponent } from './components/controls/date-picker-control/date-picker-control.component';
import { RadioControlComponent } from './components/controls/radio-control/radio-control.component';
import { SelectDropdownControlComponent } from './components/controls/select-dropdown-control/select-dropdown-control.component';
import { TextInputControlComponent } from './components/controls/text-input-control/text-input-control.component';
import { CreateRequestTaxWithholdingsComponent } from './components/create-request-tax-withholdings/create-request-tax-withholdings.component';
import { CustomErrorStandingAuthTableComponent } from './components/custom-error-standing-auth-table/custom-error-standing-auth-table.component';
import { CustomErrorTransactionTableComponent } from './components/custom-error-transaction-table/custom-error-transaction-table.component';
import { CustomErrorMasterTransactionsTableComponent } from './components/custom-error-master-transactions-table/custom-error-master-transactions-table.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DeleteStandingAuthModalComponent } from './components/delete-standing-auth-modal/delete-standing-auth-modal.component';
import { DeleteTemplateModalComponent } from './components/delete-template-modal/delete-template-modal.component';
import { EauthTableComponent } from './components/eauth-table/eauth-table.component';
import { EditAccountLevelTweModalComponent } from './components/edit-account-level-twe-modal/edit-account-level-twe-modal.component';
import { EditingRestrictedModalComponent } from './components/editing-restricted-modal/editing-restricted-modal.component';
import { ErrorSummaryComponent } from './components/error-summary/error-summary.component';
import { IneligibleAccountComponent } from './components/ineligible-eAuth-account/ineligible-account.component';
import { InputEditorComponent } from './components/input-editor-renderer/input-cell-editor.component';
import { ToAccountNumberComponent } from './components/it-to-account-number/it-to-account-number.component';
import { LabelGroupComponent } from './components/label-group/label-group.component';
import { MoneyMovementAcknowledgementSectionComponent } from './components/money-movement-acknowledgement-section/money-movement-acknowledgement-section.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { PayIncomeSelectorComponent } from './components/pay-income-selector/pay-income-selector.component';
import { RecurringFrequencySelectorComponent } from './components/recurring-frequency-selector/recurring-frequency-selector.component';
import { SetFloatingFilterComponent } from './components/set-floating-filter/set-floating-filter.component';
import { SloaNicknameComponent } from './components/sloa-nickname/sloa-nickname.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { StandingAuthorizationsTableComponent } from './components/standing-authorizations-table/standing-authorizations-table.component';
import { TableOptionComponent } from './components/table-option/table-option.component';
import { TotalsComponent } from './components/table-row-totals/table-row-totals.component';
import { TextFieldComponent } from './components/table-text-field/table-text-field.component';
import { TextFieldMultipleLotComponent } from './components/table-text-lot-input-field-multiple-to-account/table-text-lot-input-field-multiple-to-account.component';
import { InputFieldLotComponent } from './components/table-text-lot-input-field/table-text-lot-input-field.component';
import { TextFieldMultiplePositionComponent } from './components/table-text-position-input-field-multiple-to-account/table-text-position-input-field-multiple-to-account.component';
import { InputFieldPositionComponent } from './components/table-text-position-input-field/table-text-position-input-field.component';
import { TableComponent } from './components/table/table.component';
import { TextFloatingFilterComponent } from './components/text-floating-filter/text-floating-filter.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { TotalResultsComponent } from './components/total-results/total-results.component';
import { NonRegularTransactionDetailsSectionAchComponent } from './components/transaction-details-section/ach/non-regular/non-regular-transaction-details-section-ach.component';
import { TransactionDetailsSectionAchComponent } from './components/transaction-details-section/ach/transaction-details-section-ach.component';
import { TransactionDetailsSectionCheckComponent } from './components/transaction-details-section/check/transaction-details-section-check.component';
import { TransactionDetailsSectionItComponent } from './components/transaction-details-section/it/transaction-details-section-it.component';
import { TransactionDetailsSectionWireComponent } from './components/transaction-details-section/wire/transaction-details-section-wire.component';
import { TransactionReviewComponent } from './components/transaction-review/transaction-review.component';
import { TweCalculatorModalComponent } from './components/twe-calculator-modal/twe-calculator-modal.component';
import { TweModalTablesComponent } from './components/twe-modal-tables/twe-modal-tables.component';
import { TweModalComponent } from './components/twe-modal/twe-modal.component';
import { WorkInProgressComponent } from './components/work-in-progress/work-in-progress.component';
import { ClickElseWhereDirective } from './directives/click-else-where.directive';
import { TrimControlDirective } from './directives/trim-form-value.directive';
import { PIPES } from './pipes';
import * as fromSharedState from './reducers';
import { AlternatingTextLinkControlComponent } from './components/controls/alternating-text-link-control/alternating-text-link-control.component';
import { MultipleTransactionDetailsSectionItComponent } from './components/transaction-details-section/multiple-transaction-details-section-it/multiple-transaction-details-section-it.component';
import { FilePickerModalComponent } from './components/file-picker-modal/file-picker-modal.component';
import { IraCalculatorComponent } from '../account-info-header/components/ira-calculator-modal/ira-calculator-modal.component';
import { TransactionDetailsSectionWireIsoComponent } from './components/transaction-details-section/wire-iso/transaction-details-section-wire-iso.component';
import { ShowHideTextControlComponent } from './components/controls/show-hide-text-control/show-hide-text-control.component';
import { DeleteInitiatedDraftModalComponent } from './components/delete-initiated-draft-modal/delete-initiated-draft-modal.component';
import { FormatPercentPipe } from './pipes/FormatPercentPipe';
import { LegacyRedirectLandingPageComponent } from '../preview/components/legacy-redirect-landing-page/legacy-redirect-landing-page.component';
import { PrintFriendlyModalComponent } from './components/print-friendly-modal/print-friendly-modal.component';
import { AccountCellRendererComponent } from './components/account-cell-renderer/account-cell-renderer.component';
import { BookmarksModule } from '@charlesschwab/sac-ui-core';
import { CondensedLabelTopSectionComponent } from './components/condensed-layout-view/shared/condensed-label-top-section/condensed-label-top-section.component';
import { CondensedLabelGroupComponent } from './components/condensed-layout-view/shared/condensed-label-group/condensed-label-group.component';
import { TotalDistReportsStatementsComponent } from './components/total-distribution-reports-statements/total-distribution-reports-statements.component';
import { ActivityReportDownloadFieldComponent } from './components/activity-report-download-field/activity-report-download-field.component';
import { FormatDatePipe } from './pipes/FormatDatePipe';
import { ReceivingAccountDetailsCondensedComponent } from './components/condensed-layout-view/transaction-review-condensed/ach/receiving-account-details-condensed/receiving-account-details-condensed.component';
import { PtrsDetailsCondensedComponent } from './components/condensed-layout-view/shared/ptrs-details-condensed/ptrs-details-condensed.component';
import { TransactionDetailsAchCondensedComponent } from './components/condensed-layout-view/transaction-review-condensed/ach/transaction-details-ach-condensed/transaction-details-ach-condensed.component';
import { TransactionReviewAchComponent } from './components/condensed-layout-view/transaction-review-condensed/ach/transaction-review-ach.component';
import { TweDetailsSectionComponent } from './components/condensed-layout-view/shared/twe-details-section/twe-details-section.component';
import { TransactionDetailsCheckCondensedComponent } from './components/condensed-layout-view/transaction-review-condensed/check/transaction-details-check-condensed/transaction-details-check-condensed.component';
import { PayeeDetailsCheckComponent } from './components/condensed-layout-view/transaction-review-condensed/check/payee-details-check/payee-details-check.component';
import { FromAccountDetailsCondensedComponent } from './components/condensed-layout-view/shared/from-account-details-condensed/from-account-details-condensed.component';
import { TransactionReviewCheckComponent } from './components/condensed-layout-view/transaction-review-condensed/check/transaction-review-check.component';
import { TransactionReviewItComponent } from './components/condensed-layout-view/transaction-review-condensed/internal-transfer/transaction-review-it.component';
import { TransactionDetailsItCondensedComponent } from './components/condensed-layout-view/transaction-review-condensed/internal-transfer/transaction-details-it-condensed/transaction-details-it-condensed.component';
import { ReceivingAccountDetailsItCondensedComponent } from './components/condensed-layout-view/transaction-review-condensed/internal-transfer/receiving-account-details-it-condensed/receiving-account-details-it-condensed.component';
import { CondensedEauthSectionComponent } from './components/condensed-layout-view/shared/condensed-eauth-section/condensed-eauth-section.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomErrorMasterStandingAuthTableComponent } from './components/custom-error-master-standing-auth-table/custom-error-master-standing-auth-table.component';
import { TransactionReviewWireComponent } from './components/condensed-layout-view/transaction-review-condensed/wires/transaction-review-wire.component';
import { RecipientDetailsWiresCondensedComponent } from './components/condensed-layout-view/transaction-review-condensed/wires/recipient-details-wires-condensed/recipient-details-wires-condensed.component';
import { TransactionDetailsWireCondensedComponent } from './components/condensed-layout-view/transaction-review-condensed/wires/transaction-details-wire-condensed/transaction-details-wire-condensed.component';
import { TransmissionNotesComponent } from './components/condensed-layout-view/transaction-review-condensed/wires/transmission-notes/transmission-notes.component';
import { StandingAuthorizationCardContainerComponent } from './components/standing-authorization-card-container/standing-authorization-card-container.component';

const COMPONENTS = [
  WorkInProgressComponent,
  SpinnerComponent,
  TableComponent,
  TableOptionComponent,
  TextFloatingFilterComponent,
  SetFloatingFilterComponent,
  TotalsComponent,
  InputEditorComponent,
  InputFieldPositionComponent,
  InputFieldLotComponent,
  TextFieldComponent,
  TextFieldMultiplePositionComponent,
  TotalDistReportsStatementsComponent,
  TextFieldMultipleLotComponent,
  PaginationComponent,
  TotalResultsComponent,
  CustomErrorTransactionTableComponent,
  CustomErrorStandingAuthTableComponent,
  CustomErrorMasterTransactionsTableComponent,
  CustomErrorMasterStandingAuthTableComponent,
  AmountFieldComponent,
  DatePickerComponent,
  ClickElseWhereDirective,
  TrimControlDirective,
  AccountDetailsSectionComponent,
  TransactionDetailsSectionItComponent,
  TransactionDetailsSectionAchComponent,
  NonRegularTransactionDetailsSectionAchComponent,
  ClientAuthDetailsSectionComponent,
  MoneyMovementAcknowledgementSectionComponent,
  TransactionReviewComponent,
  ConfirmationDetailsSectionComponent,
  CreateRequestTaxWithholdingsComponent,
  SelectDropdownControlComponent,
  RadioControlComponent,
  AlternatingTextLinkControlComponent,
  ShowHideTextControlComponent,
  DatePickerControlComponent,
  CancelModalV2Component,
  CancelLinkModalComponent,
  EditingRestrictedModalComponent,
  AmountTypeSelectorComponent,
  TooltipComponent,
  ErrorSummaryComponent,
  AchMaxTransferAmountComponent,
  EauthTableComponent,
  ClientAuthorizationComponent,
  TweModalComponent,
  TweModalTablesComponent,
  ConfirmationPopupComponent,
  LabelGroupComponent,
  TextInputControlComponent,
  ControlLabelComponent,
  TransactionDetailsSectionWireComponent,
  TransactionDetailsSectionWireIsoComponent,
  ViewMoveMoneyPageComponent,
  TransactionDetailsSectionCheckComponent,
  BannersComponent,
  ActionsLinkComponent,
  RecurringFrequencySelectorComponent,
  PayIncomeSelectorComponent,
  IneligibleAccountComponent,
  SloaNicknameComponent,
  CashieringIraAgreementModalComponent,
  StandingAuthorizationsTableComponent,
  ToAccountNumberComponent,
  DeleteStandingAuthModalComponent,
  ConfirmPendReasonComponent,
  AchConfirmMessageComponent,
  DeleteTemplateModalComponent,
  DeleteInitiatedDraftModalComponent,
  TweCalculatorModalComponent,
  CardComponent,
  EditAccountLevelTweModalComponent,
  MultipleTransactionDetailsSectionItComponent,
  FilePickerModalComponent,
  IraCalculatorComponent,
  LegacyRedirectLandingPageComponent,
  PrintFriendlyModalComponent,
  AccountCellRendererComponent,
  CondensedLabelTopSectionComponent,
  CondensedLabelGroupComponent,
  ActivityReportDownloadFieldComponent,
  TransactionReviewCheckComponent,
  FromAccountDetailsCondensedComponent,
  PayeeDetailsCheckComponent,
  TransactionDetailsCheckCondensedComponent,
  TweDetailsSectionComponent,
  TransactionReviewAchComponent,
  ReceivingAccountDetailsCondensedComponent,
  TransactionDetailsAchCondensedComponent,
  PtrsDetailsCondensedComponent,
  TransactionReviewItComponent,
  TransactionDetailsItCondensedComponent,
  ReceivingAccountDetailsItCondensedComponent,
  CondensedEauthSectionComponent,
  TransactionReviewWireComponent,
  RecipientDetailsWiresCondensedComponent,
  TransactionDetailsWireCondensedComponent,
  TransmissionNotesComponent,
  StandingAuthorizationCardContainerComponent
]

@NgModule({
  declarations: [
    COMPONENTS,
    PIPES
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,
    BookmarksModule,
    StoreModule.forFeature(
      fromSharedState.sharedStateFeatureKey,
      fromSharedState.reducers
    ),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 4250,
      closeButton: true,
      easing: 'ease-in-out',
      easeTime: 500,
      extendedTimeOut: 500,
      preventDuplicates: true
    }),
    MatTooltipModule
  ],
  providers: [FormatPercentPipe, FormatDatePipe],
  exports: [
    COMPONENTS,
    PIPES
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
